import styled from 'styled-components';

import { media, themed } from '@/shared/ui/core';

export const NotificationStyled = styled.div.attrs({
  className: 'NotificationStyled',
})`
  padding: 1.125rem;
  margin-top: 1rem;
  position: relative;
  background-color: ${themed('primary.lightBlue')};

  @media ${media.tabletMin} {
    padding: 1rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .NotificationInner {
      padding-right: 1rem;
    }
  }
`;

export const NotificationInner = styled.div.attrs({
  className: 'NotificationInner',
})`
  width: 100%;

  .component__button {
    margin-top: 1rem;
    padding: 0.125rem;

    span {
      line-height: normal;
    }
  }

  @media ${media.tabletMin} {
    display: flex;
    align-items: center;

    .component__button {
      margin-top: 0;
      margin-left: 1rem;
      width: fit-content;
      height: 2rem;
      align-self: flex-start;
    }
  }
`;

export const MessageWrapper = styled.div.attrs({
  className: 'MessageWrapper',
})`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .Title {
    font-size: 1rem;
    width: calc(100% - 2rem);
    color: ${themed('primary.main')};
    word-break: break-word;
  }

  .Text {
    font-size: 0.875rem;
    color: ${themed('primary.text')};
    word-break: break-word;
  }

  @media ${media.tabletMin} {
  }
`;

export const NotificationCloseButton = styled.button.attrs({
  type: 'CloseButton',
})`
  background: none;
  border: none;
  width: 2rem;
  height: 2rem;
  outline: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1.6rem;
  right: -0.5rem;
  transform: translate(-50%, -50%);
  cursor: pointer;

  svg {
    fill: ${themed('primary.text')};
    width: 1.5rem;
    height: 1.5rem;
    pointer-events: none;
    transform: rotate(45deg);

    * {
      fill: ${themed('primary.text')};
    }
  }

  @media ${media.tabletMin} {
    position: relative;
    top: auto;
    right: auto;
    transform: none;
  }
`;
